export default __webpack_public_path__ + "static/media/delete.89cb2323.svg";